import React, { useEffect, useState } from 'react';
import BOLayout from '@/pages/back-office/BOLayout';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Modal from '@/components/Modal';
import SettingsTopBanner from '@/components/back-office/SettingsTopBanner';
import TableHeaders from '@/components/back-office/users/tables/TableHeaders';
import TableRows from '@/components/back-office/users/tables/TableRows';
import Pagination from '@/components/back-office/Pagination';
import BONavigationButton from '@/components/back-office/BONavigationButton';

const UsersList = () => {
	const [users, setUsers] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [userEmail, setUserEmail] = useState(null);
	const email = JSON.parse(localStorage.getItem('user'))?.email;
	const role = JSON.parse(localStorage.getItem('role'));
	const navigate = useNavigate();
	const [currentPage, setCurrentPage] = useState(1); // Ajout de l'état pour la page actuelle
	const usersPerPage = 10; // Nombre d'utilisateurs par page
	const onPageChange = (pageNumber) => setCurrentPage(pageNumber); // Fonction pour changer de page

	useEffect(() => {
		if (role && role !== 'super-admin') {
			toast.info('Zone interdite', {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});

			navigate('/back-office');

			return;
		}
	}, [role]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${import.meta.env.VITE_API_URL}/api/back-office/settings/users/list`, {
					params: {
						email: email,
					},
				});

				if (response.status === 200) {
					setUsers(response.data);
				}
			} catch (error) {
				console.error('Error fetching users:', error);
				toast.error('Une erreur est survenue', {
					position: 'top-center',
					autoClose: 3500,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					theme: 'colored',
				});
			}
		};

		fetchData();
	}, []);

	const handleModalSubmit = async () => {
		try {
			await axios.delete(`${import.meta.env.VITE_API_URL}/api/back-office/settings/users/${userEmail}/delete`);

			toast.success('Utilisateur supprimé avec succès', {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});
		} catch (error) {
			console.error('Error deleting user:', error);
			toast.error('Une erreur est survenue', {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});
		}

		setTimeout(() => {
			navigate(0);
		}, 1500);
	};

	const indexOfLastUser = currentPage * usersPerPage;
	const indexOfFirstUser = indexOfLastUser - usersPerPage;
	const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser); // Utilisateurs à afficher sur la page actuelle

	return (
		<BOLayout>
			<div className="mb-4 grid grid-cols-1 gap-12">
				<SettingsTopBanner />
				<h1 className="text-3xl font-bold text-center">Liste des utilisateurs</h1>
				<BONavigationButton
					text={'Créer un utilisateur'}
					navigationRoute={`/back-office/settings/users/creation`}
				/>
			</div>

			{showModal && (
				<Modal
					type={'danger'}
					title={'Cette action est irréversible'}
					setShowModal={setShowModal}
					handleSubmit={handleModalSubmit}
				/>
			)}

			<table className="table table-striped table-bordered table-fixed w-full text-center">
				<thead className="border-b border-b-black pb-2 mb-4">
					<TableHeaders headers={['Nom', 'Téléphone', 'Email', 'Actions']} />
				</thead>
				<tbody>
					<TableRows rows={currentUsers} setShowModal={setShowModal} setUserEmail={setUserEmail} />
				</tbody>
			</table>

			{/* Utilisation du composant Pagination */}
			<Pagination
				currentPage={currentPage}
				totalItems={users.length}
				itemsPerPage={usersPerPage}
				onPageChange={onPageChange}
			/>

			{users.length === 0 && <div className="flex justify-center">Aucun utilisateur</div>}
		</BOLayout>
	);
};

export default UsersList;
